import React from 'react';
import { Button } from './ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { mockData } from '../mock';

export const Hero = () => {
  return (
    <section
      className="pb-14 bg-gradient-to-br from-blue-50 via-white to-indigo-50"
      // Top padding = base header offset (5rem = pt-20) PLUS the launch
      // banner's published height. When the banner is dismissed, the
      // variable drops to 0 and the hero reflows tight against the header.
      style={{ paddingTop: 'calc(5rem + var(--launch-banner-h, 0px))' }}
      data-testid="hero-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Main Headline */}
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            {mockData.hero.headline}
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto">
            {mockData.hero.subheadline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button 
              size="lg" 
              className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold px-8 py-3 text-lg shadow-lg hover:shadow-xl transition-all duration-300"
              onClick={() => {
                const element = document.getElementById('memberships');
                if (element) {
                  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                  const offsetPosition = elementPosition - 100; // Offset for header
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                  });
                }
              }}
            >
              Explore Memberships
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 px-8 py-3 text-lg"
              onClick={() => {
                const element = document.getElementById('ultimate-hr-bundle');
                if (element) {
                  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                  const offsetPosition = elementPosition - 100; // Offset for header
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                  });
                }
              }}
            >
              Browse HR Templates
            </Button>
          </div>

          {/* Trust Signals */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
            {mockData.hero.trustSignals.map((signal, index) => (
              <div key={index} className="text-center">
                <CheckCircle className="w-8 h-8 text-green-500 mx-auto mb-3" />
                <h3 className="font-bold text-gray-900 mb-2">{signal.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{signal.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};